import React, { memo, useEffect } from 'react';
import type { FC } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate,Outlet} from "react-router-dom";
import { I18nextProvider } from 'react-i18next';
import i18n from './i18nextSetup';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import LanguageInitializer from './LanguageInitializer';
import DynamicLangHelmet from './DynamicLangHelmet';
import classes from './App.module.css';
import Header from "./components/common/Navigation/Header";
import { Footer } from "./components/common/Footer/Footer";
import { Top } from './components/Top/Top';
import { About_edu } from './components/About_edu/About_edu';
import { StudentClub } from './components/StudentClub/StudentClub';
import { UsageEx } from './components/UsageEx/UsageEx';
import NewsList from "./components/common/PostList/PostList";
import PostDetail from './components/common/PostList/PostDetail';
import { SchoolList } from './components/Top/SchoolList';

interface Props {
  className?: string;
}


const AnimatedRoutesWrapper: FC = () => {
  const location = useLocation();

  return (
    
    <TransitionGroup>
      <CSSTransition
        timeout={500}
        classNames="fade"
        key={location.pathname} 
        unmountOnExit
      >
        <div className="fade-transition-element">
          <Routes>
              <Route path="/:lang">
                <Route index element={<Top />} />
                <Route path="about" element={<Outlet />}>
  <Route index element={<About_edu />} />
  <Route path="usage-ex" element={<UsageEx />} />
</Route>
                <Route path="student-club" element={<StudentClub />} />
                <Route path="news" element={<NewsList limit={12} />} />
                <Route path="interview" element={<NewsList categoryId={119} limit={12} />} />
                <Route path="research-result" element={<NewsList categoryId={121} limit={12} />} />
                <Route path="post/:id" element={<PostDetail />} />
                <Route path="school-list" element={<SchoolList />} />
              </Route>
              <Route path="/" element={<Navigate to="/ja" replace />} />
            </Routes>
        </div>
      </CSSTransition>
    </TransitionGroup>
  );
};


const ScrollToTop: FC = () => {
  const { pathname, hash } = useLocation();
  
  useEffect(() => {
    if (hash) {
      // ハッシュリンクがある場合は、該当する要素にスクロール
      const element = document.getElementById(hash.substring(1));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    } else {
      // ハッシュがない場合はトップにスクロール
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  
  return null;
};

export const App: FC<Props> = memo(function App(props = {}) {
  return (
    <div className={classes.root}>
      <DynamicLangHelmet />
    <I18nextProvider i18n={i18n}>
      <Router basename="/education">
        <LanguageInitializer /> 
        <ScrollToTop />
        <Header />
        <AnimatedRoutesWrapper />
        <Footer />
      </Router>
    </I18nextProvider>
  </div>
  );
});
